import React, { Component } from 'react';

import { WithStyles, withStyles } from '@mui/styles';
import { withTranslate } from '../../../core/TenantProvider';

import APPasswordCriteriaStyle from "./styles/APPasswordCriteria.style";
import { ReactComponent as TickIcon } from './assets/icon-tick.svg';

interface APLogoProps extends WithStyles<typeof APPasswordCriteriaStyle> {
    translate: Function,
    className?: string,
    inputValue?: string
}

class APPasswordCriteria extends Component<APLogoProps, {}> {

    checkString(inputValue: any, type: string) {

        if (inputValue) {
            switch (type) {
                case 'length':
                    return inputValue.length > 9;

                case 'lessthan':
                    return inputValue.length < 17;

                case 'lower':
                    return /[a-z]/.test(inputValue); /*eslint-disable-line*/

                case 'upper':
                    return /[A-Z]/.test(inputValue); /*eslint-disable-line*/

                case 'special':
                    return /(?=.*[!@#$%^&*"£^()+={}\|?><,._])(?=.*[0-9])/.test(inputValue); /*eslint-disable-line*/
                default:
            }
        }

        return false;
    }

    render() {
        const { translate, classes, inputValue } = this.props;
        return (
            <div className={classes.passwordCriteria}>
                <h3>{translate('password.criteria.heading')}</h3>
                <ul>
                    <li className={this.checkString(inputValue, 'length') ? 'valid' : ''}>{<TickIcon />} {translate('password.criteria.list.item1')}</li>
                    <li className={this.checkString(inputValue, 'lessthan') ? 'valid' : ''}>{<TickIcon />} {translate('password.criteria.list.item2')}</li>
                    <li className={this.checkString(inputValue, 'lower') ? 'valid' : ''}>{<TickIcon />} {translate('password.criteria.list.item3')}</li>
                    <li className={this.checkString(inputValue, 'upper') ? 'valid' : ''}>{<TickIcon />} {translate('password.criteria.list.item4')}</li>
                    <li className={this.checkString(inputValue, 'special') ? 'valid' : ''}>{<TickIcon />} {translate('password.criteria.list.item5')}</li>
                </ul>
            </div>
        );
    }
}

export default withTranslate(withStyles(APPasswordCriteriaStyle)(APPasswordCriteria));